// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type AanvragenDomainEntitiesOntvangerDirectePost =
  (typeof AanvragenDomainEntitiesOntvangerDirectePost)[keyof typeof AanvragenDomainEntitiesOntvangerDirectePost];

export const AanvragenDomainEntitiesOntvangerDirectePost = {
  Relatie: 'Relatie',
  Adviseur: 'Adviseur',
  Beide: 'Beide',
} as const;
